
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: 'Use Plaid and Square to accept ACH payments',
  preloadImages: [{
    src: '/assets/img/docs/plaid-square-partnership.png',
    type: 'image/webp'
  }]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Integrate Plaid with Square' subtitle={metadata.description} mdxType="Header" />
    <Image src='/assets/img/docs/plaid-square-partnership.png' alt="Plaid and Square logos, side by side." width='624' mdxType="Image" />
    <br />
    <p>{`Plaid and Square have partnered together to offer businesses and developers an easier way to accept ACH payments. Square leverages Plaid Link to instantly authenticate a customer's bank account. Plaid ensures businesses will not need to collect or provide any banking information on their own. Once an account is authenticated, any business can accept ACH Payments through Square's `}<a parentName="p" {...{
        "href": "https://developer.squareup.com/docs/web-payments/add-ach"
      }}>{`Web Payments SDK`}</a>{` and `}<a parentName="p" {...{
        "href": "https://squareup.com/us/en/invoices"
      }}>{`Square Invoices`}</a>{`.`}</p>
    <h4 {...{
      "id": "why-square"
    }}>{`Why Square?`}</h4>
    <p>{`Square is a leader in payment solutions for small businesses, offering powerful tools to enable any business to send and receive payments. Square is enabling ACH via Web Payments SDK to help developers build innovative online payment experiences and via Square Invoices to help businesses accept flexible payment methods. ACH is ideal for businesses in professional services, wholesale, and other verticals where large transactions are common and getting paid remotely is essential. When you integrate Square with Plaid, Square will not charge for any fees associated with an ACH refund, helping simplify the costs and return risk of ACH.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <p>{`This integration is designed for developers and businesses who have signed up for a Square account. As a developer, you will need to enable the Square Web Payment SDK in your application and create an application through the Square Quickstart project before enabling ACH. Once enabled, you will be able to access Plaid Link directly through the Square Web Payments SDK. As a business, you can accept ACH payments directly through Square Invoices without any additional integration work. For more information, please review Square's API docs and `}<a parentName="p" {...{
        "href": "https://developer.squareup.com/docs/web-payments/add-ach"
      }}>{`sign up for a Square Account`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "why-square",
        level: 4,
        title: "Why Square?",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
